// extracted by css-extract-rspack-plugin
export default {"CreateIssueContainer":"CreateIssue-module__CreateIssueContainer__GAFFfmf","LoadingContainer":"CreateIssue-module__LoadingContainer__E9w12m0"};